import { StyleSheet } from "aphrodite";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IStyle {
  modalButton: any;
  modalIcon: any;
}

export const SelectionModalDialogStyle: IStyle = StyleSheet.create({
  modalButton: {
    maxWidth: "300px",
    margin: "0 auto",
    paddingTop: space.atom2x,
  },
  modalIcon: {
    display: "block",
    width: "48px",
    height: "48px",
    lineHeight: "48px",
    fontSize: "28px",
    margin: `${space.atom} auto ${space.atom1_5x}`,
    background: "#ccc",
    color: "#fff",
    borderRadius: "50%",
    textAlign: "center",
    [moreThanBreakpoint("tablet")]: {
      margin: `0 auto ${space.atom2x}`,
    },
  },
});
